import { useRuntimeConfig } from "#imports";
export const useEchoConfig = () => {
  return useRuntimeConfig().public.echo;
};
